import Vue from 'vue'
import Vuetify from 'vuetify'
import { ClinicalStore } from '@/store/store'
import { ClinicalRouter } from '@/router'
import { vuetifyConfig } from '@/assets/vuetify-config'
import App from '@/App'

export function initializeClinicalApplication(el) {
  const store = ClinicalStore()
  const vue = new Vue({
    store: store,
    router: ClinicalRouter(store),
    vuetify: new Vuetify(vuetifyConfig),
    render: h => h(App)
  })

  vue.$mount(el)

  return vue
}
